<template>
<div class="chapter">
<div class="inner_page">
<h2 id="sigil_toc_id_4"></h2>
<div>
<p class="body"></p>
<p class="body"></p>
<p class="body"></p>
<p class="firstcenter">I dedicate this book to Noah and Sophia, my first two children. May you grow up to be bold and loving witnesses for Christ. I hope you have the opportunity to see many people experience Jesus through your life and testimony.</p>
<p class="body"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?37d5ae69